// Module
var code = "<organism-global-search ng-if=\"$resolve.userHasRightAdminSystemSuperUserRead\"></organism-global-search> <organism-global-translation-id-list></organism-global-translation-id-list> <div class=\"flexWrapper__page\"> <div ui-view=\"content\"></div> </div> ";
// Exports
module.exports = code;